import ReactDom from "react-dom";
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";

const PersonalLifeCarousel = ({ photo, onClose }) => {



    if (!photo) return null;


    return ReactDom.createPortal(
        <>
            <AnimatePresence>
                {photo && (
                    <motion.div className="mymodal-overlay" onClick={onClose}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}

                    >
                        <motion.div
                            className="mymodal-content"
                            onClick={(e) => e.stopPropagation()}
                            initial={{ opacity: 0, y: -100 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 100 }}
                        >
                            <img
                                src={photo.imageUrl}
                                alt={photo.caption || "Photo"}
                                className="mymodal-image"
                                onClick={onClose}

                            />

                            {photo.caption && (
                                <div className="mymodal-caption">
                                    {photo.caption}
                                </div>
                            )}
                        </motion.div>
                    </motion.div>

                )}
            </AnimatePresence>
        </>,
        document.getElementById('portal')

    );
};

export default PersonalLifeCarousel;
